import { PRICE_PROMOTION_GROUPS_VALUES } from 'chemistry'
import { BANNER_TYPE } from './constants'

export const getBannerType = ({ productDetails, discountData }) => {
  const { discount, bonusBuysDiscount, promotion } = discountData
  const hasPotentialPromotions =
    Array.isArray(productDetails.potentialPromotions) && productDetails.potentialPromotions.length > 0
  const hasDeliveryPromotions =
    Array.isArray(productDetails.deliveryPromotions) && productDetails.deliveryPromotions.length > 0

  if ((!discount || !hasPotentialPromotions) && !bonusBuysDiscount && !hasDeliveryPromotions) {
    return null
  }

  if (hasDeliveryPromotions) return BANNER_TYPE.DELIVERY

  if (typeof discount !== 'object' && PRICE_PROMOTION_GROUPS_VALUES.includes(promotion.promotionGroup)) {
    return BANNER_TYPE.PRICE
  }

  const { sameProducts, isQualified, isTarget } = discount?.promoValue || {}
  if (sameProducts || (isQualified && isTarget)) return BANNER_TYPE.EQUAL
  if (isTarget) return BANNER_TYPE.TARGET
  if (isQualified) return BANNER_TYPE.QUALIFIED
  return null
}
